// extracted by mini-css-extract-plugin
module.exports = {"sectorDetailsGrid":"SectorDetails_sectorDetailsGrid__2F7wa"};